var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full relative rounded-2xl overflow-hidden background"},[_vm._t("header-hero"),_vm._v(" "),_c('div',[_vm._t("button")],2),_vm._v(" "),_c('div',{staticClass:"max"},[_vm._t("header-showcase")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }